const o = "loadMore_inybZ", e = {
  loadMore: o
};
export {
  e as default,
  o as loadMore
};
//# sourceMappingURL=loadMore.module.scss.js.map
